/* eslint-disable no-restricted-globals */
import { browserSessionStore } from '@tassat/utility';

function getVersion() {
    let TPAY_MAJOR_NUMBER;
    let TPAY_MINOR_NUMBER;
    let TPAY_RELEASE_NUMBER;
    let TPAY_BUILD_NUMBER;
    let TPAY_VERSION;

    /* configure the TPAY-UI version here */
    TPAY_MAJOR_NUMBER = '1';
    TPAY_MINOR_NUMBER = '4';
    TPAY_RELEASE_NUMBER = '1';
    TPAY_BUILD_NUMBER = '';

    TPAY_VERSION = `${TPAY_MAJOR_NUMBER}.${TPAY_MINOR_NUMBER}.${TPAY_RELEASE_NUMBER}`;

    return {
        TPAY_VERSION,
        TPAY_MAJOR_NUMBER,
        TPAY_MINOR_NUMBER,
        TPAY_RELEASE_NUMBER,
        TPAY_BUILD_NUMBER
    };
}

const getBasePath = (pathname) => (pathname.substring(0, pathname.lastIndexOf('/') + 1));

function getNetworkConfiguration() {
    let CLIENT_PUBLIC_IP;
    let ADMIN_PUBLIC_IP;
    let TPAY_CLIENT_HOST;
    let TPAY_ADMIN_HOST;
    let TPAY_CLIENT_PORT_WS;
    let TPAY_ADMIN_PORT_WS;
    let USE_WSS;
    let IS_ADMIN_URL;

    TPAY_CLIENT_PORT_WS = 443;
    TPAY_ADMIN_PORT_WS = 443;
    USE_WSS = location.protocol === 'https:';

    const origin = location.origin;
    ADMIN_PUBLIC_IP = origin;
    TPAY_ADMIN_HOST = getBasePath(origin);
    CLIENT_PUBLIC_IP = origin;
    TPAY_CLIENT_HOST = getBasePath(origin);

    // Allow both admin and client on localhost
    if (/localhost/.test(origin)) {
        ADMIN_PUBLIC_IP = origin;
        TPAY_ADMIN_HOST = getBasePath(origin);
        TPAY_ADMIN_PORT_WS = 26000;
        CLIENT_PUBLIC_IP = origin;
        TPAY_CLIENT_HOST = getBasePath(origin);
        TPAY_CLIENT_PORT_WS = 27000;
        USE_WSS = false;
    }

    // TPAY_ADMIN_HOST = 'http://admin-wallet-qa.in.truedgtl.com/';
    // TPAY_CLIENT_HOST = 'http://wallet-qa.in.truedgtl.com/';
    // TPAY_ADMIN_PORT_WS = '443';
    // TPAY_CLIENT_PORT_WS = '443';
    // USE_WSS = true;

    return {
        CLIENT_PUBLIC_IP,
        ADMIN_PUBLIC_IP,
        TPAY_CLIENT_HOST,
        TPAY_ADMIN_HOST,
        TPAY_CLIENT_PORT_WS,
        TPAY_ADMIN_PORT_WS,
        USE_WSS,
        IS_ADMIN_URL
    };
}

export async function getAuthConfiguration(useSessionStore = true) {
    if (useSessionStore) {
        try {
            const storedAuthConfigs = browserSessionStore.getItem('auth_config');
            if (storedAuthConfigs) {
                const authConfig = JSON.parse(storedAuthConfigs);

                return authConfig;
            }
        } catch (error) {
            // Do nothing, will fall into fetch case below if not valid JSON or missing encryption values
        }
    }

    const response = await fetch('/auth');
    const encryptedData = await response.text();
    const { default: encryptDecrypt } = await import('../src/lib/encryptDecryptToken');
    const authConfig = JSON.parse(encryptDecrypt.decrypt(
        encryptedData,
        import.meta.env.ENCRYPT_KEY.substring(0, 10),
        import.meta.env.ENCRYPT_KEY.substring(10)
    ));

    if (useSessionStore) {
        try {
            browserSessionStore.setItem('auth_config', JSON.stringify(authConfig));
        } catch (error) {
            // Do nothing, will just fetch on next auth request
        }
    }

    return authConfig;
}

export default {
    network: getNetworkConfiguration(),
    version: getVersion()
};